import { Hero } from "@/sections/Hero";
import { TrustStrip } from "@/sections/TrustStrip";
import { Features } from "@/sections/Features";
import { HowItWorks } from "@/sections/HowItWorks";
import { Showcase } from "@/sections/Showcase";
import { PricingSection } from "@/sections/PricingSection";
import { FAQSection } from "@/sections/FAQSection";
import { DownloadCTA } from "@/sections/DownloadCTA";
import { useSeo } from "@/components/site/Seo";

export default function Home() {
  useSeo({
    title: "",
    description:
      "Velora Intelligence is an AI-powered cryptocurrency intelligence platform for crypto market analysis, risk analysis, presale intelligence, smart monitoring and portfolio tracking.",
    path: "/",
  });
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustStrip />
      <Features />
      <HowItWorks />
      <Showcase />
      <PricingSection />
      <FAQSection />
      <DownloadCTA />
    </main>
  );
}
